export const bulkContractAddress = '0xb0609563d9A79d99682dAA7301d8F4B7363fB216'
